import { CountriesGetResponse } from '@flowio/api-sdk';
import { getCountriesStatus } from '../selectors';
import ActionTypes from '../constants/ActionTypes';
import ReadyState from '../../../utilities/redux/ReadyState';
import { ThunkDispatcher, ThunkExtraArguments, RootState } from '../../../stores/types';
import { PropType } from '../../../types';
import { LegacyResponse } from '../../../utilities/clients/types/server';
import standardAction from '../../../utilities/standard-action';
import formatErrorResponseV2 from '../../../utilities/format-error-response-v2';
import toLegacyResponse from '../../../utilities/clients/to-legacy-response';

type ResponseType = PropType<CountriesGetResponse, 'body'>;

export default function fetchCountries() {
  return (
    dispatch: ThunkDispatcher,
    getState: () => RootState,
    extra: ThunkExtraArguments,
  ): Promise<LegacyResponse<ResponseType> | void> => {
    const state = getState();
    if (getCountriesStatus(state) === ReadyState.FULFILLED) {
      return Promise.resolve();
    }

    dispatch({
      type: ActionTypes.FETCH_COUNTRIES_REQUEST,
    });

    return extra.api(state).countries.get()
      .then((response) => {
        if (response.ok) {
          dispatch(standardAction(
            ActionTypes.FETCH_COUNTRIES_SUCCESS,
            response.body,
          ));
        } else {
          dispatch(standardAction(
            ActionTypes.FETCH_COUNTRIES_FAILURE,
            formatErrorResponseV2(response),
          ));
        }
        return toLegacyResponse<ResponseType>(response);
      });
  };
}
